import type { InputHTMLAttributes, SelectHTMLAttributes, ReactNode } from "react";

const labelClass = "text-[11px] font-semibold text-slate-500 dark:text-slate-400";
const inputClass = "mt-1 w-full text-sm border border-slate-200 dark:border-white/10 rounded-lg px-3 py-2 bg-white dark:bg-white/5 outline-none focus:ring-2 focus:ring-sbd-yellow/50";

export function FieldReadonly({ label, value }: { label: string; value: ReactNode }) {
  return (
    <div>
      <label className={labelClass}>{label}</label>
      <div className="mt-1 text-sm border border-slate-200 dark:border-white/10 rounded-lg px-3 py-2 bg-slate-50 dark:bg-white/5">{value}</div>
    </div>
  );
}

export function FieldInput({ label, ...rest }: { label: string } & InputHTMLAttributes<HTMLInputElement>) {
  return (
    <div>
      <label className={labelClass}>{label}</label>
      <input className={inputClass} {...rest} />
    </div>
  );
}

export function FieldSelect({
  label,
  options,
  ...rest
}: { label: string; options: Array<{ value: string | number; label: string }> } & SelectHTMLAttributes<HTMLSelectElement>) {
  return (
    <div>
      <label className={labelClass}>{label}</label>
      <select className={inputClass} {...rest}>
        {options.map((o) => (
          <option key={o.value} value={o.value}>
            {o.label}
          </option>
        ))}
      </select>
    </div>
  );
}

export function DateFormatRadios({ dash = false, value, onChange }: { dash?: boolean; value: string; onChange: (v: string) => void }) {
  const opts = dash ? ["DD-MMM-YYYY", "MM-DD-YYYY", "DD-MM-YYYY"] : ["DD/MMM/YYYY", "MM/DD/YYYY", "DD/MM/YYYY"];
  return (
    <div>
      <label className={labelClass}>Date Format (Report Display)</label>
      <div className="mt-1 flex gap-4 text-sm">
        {opts.map((o) => (
          <label key={o} className="flex items-center gap-1.5">
            <input type="radio" name="df" checked={value === o} onChange={() => onChange(o)} /> {o}
          </label>
        ))}
      </div>
    </div>
  );
}
